<mat-form-field appearance="outline"
                [cllTooltip]="selectedOptionsLabel">
    <mat-label *ngIf="label">
        {{ label }}
    </mat-label>

    <mat-select #selectComponent
                [(ngModel)]="selectedOptions"
                [placeholder]="placeholder"
                [required]="required"
                [disabled]="disabled"
                [compareWith]="compareWith"
                [multiple]="true"
                (selectionChange)="onSelectionChange($event)">
        <mat-select-trigger>
            <ng-container *ngIf="triggerLabel; else noTriggerLabel">
                <span [innerHTML]="triggerLabel"></span>
            </ng-container>

            <ng-template #noTriggerLabel>
                <app-badge *ngIf="selectedOptions?.length > maxSelectedShowing; else optionBadges">
                    {{ selectedOptions.length }} selected
                </app-badge>

                <ng-template #optionBadges>
                    <app-badge-collection>
                        <app-badge *ngFor="let option of selectedOptions"
                                   style="margin-top: 1px">
                            {{ option.label }}
                        </app-badge>
                    </app-badge-collection>
                </ng-template>
            </ng-template>
        </mat-select-trigger>

        <ng-container *ngIf="allowSelectAll">
            <div class="mat-option select-all-option"
                 matRipple
                 [class.mat-option-disabled]="allEnabledOptionsSelected"
                 [matRippleDisabled]="allEnabledOptionsSelected"
                 *ngIf="(!allowDeselectAll || !allEnabledOptionsSelected) && options?.length"
                 (click)="selectAll()"
                 data-testid="button:select-all">
                <cll-icon>done_all</cll-icon>
                <span class="mat-option-text">Select all</span>
            </div>
        </ng-container>

        <ng-container *ngIf="allowDeselectAll">
            <div class="mat-option select-all-option"
                 *ngIf="allEnabledOptionsSelected"
                 matRipple
                 (click)="deselectAll()">
                <cll-icon>clear</cll-icon>
                <span class="mat-option-text">De-select all</span>
            </div>
        </ng-container>

        <mat-option *ngFor="let option of options"
                    [value]="option"
                    [disabled]="option.disabled || isOptionDisabled(option)"
                    [class.has-avatar]="option.has_avatar || option.avatar_url"
                    [attr.data-testid]="option.label">
            <app-select-option [option]="option" />

            <a class="only"
               *ngIf="allowOnly && $any(option.value)?.id !== 'all' && !isOptionDisabled(option)"
               (click)="selectOne($event, option)">
                Only
            </a>
        </mat-option>

        <mat-option *ngIf="!options?.length"
                    [disabled]="true">
            No options available
        </mat-option>
    </mat-select>

    <div matSuffix>
        <button class="clear-button"
                *ngIf="clearable"
                cll-icon-button
                (click)="clear($event)">
            <cll-icon>clear</cll-icon>
        </button>

        <mat-spinner [diameter]="20"
                     *ngIf="fetching"
                     cllTooltip="Fetching data" />
    </div>


    <mat-hint *ngIf="hint">
        {{ hint }}
    </mat-hint>

    <mat-error *ngFor="let message of errorMessages">
        {{ message }}
    </mat-error>
</mat-form-field>
